import { InjectionToken } from '@angular/core';
import { IFilterFacet } from '@impact/data';
import { Observable } from 'rxjs';

export interface IPageFacets {
    purchaseOptions?: Record<string, IFilterFacet | undefined>;
    showOnly?: Record<string, IFilterFacet | undefined>;
    sorted?: IFacetGroup[];
    unsorted?: Record<string, IFilterFacet>;
}

export interface IFacetGroup {
    key: string;
    options: IFilterFacet;
}

export interface MobileFacetListData {
    facets: Observable<IPageFacets>;
}

export const COLLAPSE_PANELS = new InjectionToken<boolean>('collapsepanel');
